import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Drawer,
  IconButton,
  Button,
  Box,
  Typography,
  Badge,
  Skeleton,
  ListItemButton,
  Avatar,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import sLogo from "../../assets/Logo/logo-new.svg";
import Logo from "../../assets/Logo/auth-logo.svg";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";

import shoppingCartIcon from "../../assets/Icons/shopping_cart.svg";
import wishListIcon from "../../assets/Icons/fave.svg";
import andriod from "../../assets/images/andriod.svg";
import apple from "../../assets/images/apple.svg";

import { logoutUser } from "../../store/userSlice";
import { GET_CATEGORIES_N_SUB } from "../../Utils/Queries";
import { useQuery, gql } from "@apollo/client";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useGetCart from "../../Hooks/useGetCart";
import useGetServiceCart from "../../Hooks/useGetServiceCart";
import useGetFav from "../../Hooks/useGetFav";
import { TfiClose } from "react-icons/tfi";
import loginIcon from "../../assets/Icons/user-login.svg";
import useAuthFlow from "../../Hooks/use-auth-flow";
import accountIcon from "../../assets/Icons/nav/account.svg";
import shopIcon from "../../assets/Icons/nav/shop.svg";
import purseIcon from "../../assets/Icons/nav/Wallet.svg";
import boxIcon from "../../assets/Icons/nav/box.svg";
import { LiaPowerOffSolid } from "react-icons/lia";
import { CartActionBadge } from "./Navbar";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const GET_CART_ITEMS = gql`
  query GetCartItems {
    cartItems @client
  }
`;
const GET_SERVICE_CART = gql`
  query GetServiceItems {
    serviceCarts @client
  }
`;

const GET_FAV_CART = gql`
  query GetFavItems {
    favItemsVar @client
  }
`;

const Drawers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: product_cart } = useQuery(GET_CART_ITEMS);
  const { data: serviceCart } = useQuery(GET_SERVICE_CART);
  const { data: favItems } = useQuery(GET_FAV_CART);

  const favProducts = useSelector((state) => state.favourite);

  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [collapse, setCollapse] = useState(false);

  const isAuthenticated = useSelector((state) => state.user?.isAuthenticated);
  const userInfo = useSelector((state) => state.user?.user?.profile);

  const { loading, data, error } = useQuery(GET_CATEGORIES_N_SUB);

  const { handleGetCart, refetch } = useGetCart();
  const { handleGetCart: handleServiceCart, refetch: refecthCart } =
    useGetServiceCart();

  const { handleGetFav, refetch: favRefetch } = useGetFav();

  useEffect(() => {
    handleGetCart();
    refetch();
    handleServiceCart();
    refecthCart();
    favRefetch();
    handleGetFav();
  }, []);

  const cartProducts = data?.cartItems || [];

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [color, setColor] = useState(false);

  const changeColor = () => {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  const handleLogOut = () => {
    navigate("/");
    setAnchorEl(null);
    dispatch(logoutUser());
  };

  const isSeller = useSelector(
    (state) => state.user?.user?.profile?.hasPaidMembershipFee,
  );

  const getInitials = (user) => {
    if (!user) return "?";
    return `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();
  };

  const { triggerAuth } = useAuthFlow();
  return (
    <>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Box
          sx={{
            width: "85vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <div>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
                p: 2,
                borderBottom: "1px solid #001A2B1A",
              }}
            >
              <Link to="/" className="flex-1">
                <img src={Logo} width={80} style={{ marginTop: "10px" }} />
              </Link>

              <div className="">
                <IconButton
                  onClick={() => setOpenDrawer(!openDrawer)}
                  sx={{ mr: 2 }}
                >
                  <TfiClose className="text-[16px] text-[#FF465C]" />
                </IconButton>
              </div>
            </Box>
          </div>

          {isAuthenticated && (
            <div className="mt-2">
              <div className="px-3">
                <span className="text-[#333] text-[12px]">ACCOUNT</span>
              </div>
              <div className="mt-7">
                <Link
                  to="/account"
                  className="flex items-center gap-x-4 px-3 pb-3"
                  style={{ borderBottom: "1px solid #F7F6F6" }}
                >
                  <img src={accountIcon} alt="profile" className="w-3" />
                  <span className="text-[#3D3D3D] text-[12px]">My Account</span>
                </Link>
                <Link
                  to="/sell-on-mamaket"
                  className="flex items-center gap-x-3 mt-3 px-3 pb-3"
                  style={{ borderBottom: "1px solid #F7F6F6" }}
                >
                  <img src={shopIcon} alt="profile" className="w-4" />
                  <span className="text-[#3D3D3D] text-[12px]">
                    Sell on Mamaket
                  </span>
                </Link>
                <Link
                  to="/account/mamapurse"
                  className="flex items-center gap-x-3 px-3 mt-3 pb-3"
                  style={{ borderBottom: "1px solid #F7F6F6" }}
                >
                  <img src={purseIcon} alt="profile" className="w-5 " />
                  <span className="text-[#3D3D3D] text-[12px]">Mamapurse</span>
                </Link>
                <Link
                  to="/account/orders"
                  className="flex items-center gap-x-3 mt-3 px-3 pb-3"
                  style={{ borderBottom: "1px solid #F7F6F6" }}
                >
                  <img src={boxIcon} alt="profile" className="w-5" />
                  <span className="text-[#3D3D3D] text-[12px]">My Order</span>
                </Link>
              </div>
            </div>
          )}

          <Box
            sx={{
              mt: 3,
              flex: 1,
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                width: "0", // Set the width of the scrollbar to zero
              },
            }}
          >
            <Box sx={{ mb: 2, px: 1 }}>
              <Box
                onClick={() => setCollapse(!collapse)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  pb: 1,
                }}
                style={{ borderBottom: "1px solid #F7F6F6" }}
              >
                <Typography
                  sx={{ fontWeight: 700, color: "#575f6d", fontSize: "14px" }}
                >
                  Categories
                </Typography>
                <IconButton onClick={() => setCollapse(!collapse)}>
                  {collapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </Box>
              <Box
                sx={{
                  pl: 2,
                  display: collapse ? "block" : "none",
                  borderLeft: "1px solid #dee0e7",
                }}
              >
                {loading ? (
                  <>
                    <ListLoader />
                  </>
                ) : (
                  <>
                    {data?.fetchAllCategoriesAndTheirSubCategories.map(
                      (item, index) => (
                        <Link
                          className="w-full"
                          to={`/category-view/${item.category.name}/${item.category._id}`}
                        >
                          <ListItemButton
                            key={index}
                            sx={{
                              p: 0,
                              px: 1,
                              py: 0.5,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                              width: "100%",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#575f6d",
                                fontWeight: 500,
                                fontSize: "13px",
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {item?.category?.name}
                            </Typography>

                            <IconButton>
                              {/* <ChevronRightIcon /> */}
                            </IconButton>
                          </ListItemButton>
                        </Link>
                      ),
                    )}
                  </>
                )}
              </Box>
            </Box>
            <div className="mt-5 px-3 ">
              <span className="text-[12px] text-[#9D9FA4]">MAMAKET</span>
            </div>

            <div className="mt-5 px-3 flex flex-col gap-y-3">
              <Link to="/about-us">
                <span className="text-[#626262] text-[12px] font-medium">
                  About Mamaket
                </span>
              </Link>
              <Link to="/blog">
                <span className="text-[#626262] text-[12px] font-medium">
                  Our Blog
                </span>
              </Link>
              <Link to="/account/orders">
                <span className="text-[#626262] text-[12px] font-medium">
                  Track My Order
                </span>
              </Link>
            </div>

            <div className="mt-10">
              <div className="flex items-center justify-evenly">
                <a href="https://play.google.com/store/apps/details?id=com.mamaket.mobile2026">
                  <img
                    src={andriod}
                    alt="Download on Google Play"
                    width="120"
                    height="40"
                    loading="lazy"
                  />
                </a>
                <a href="https://apps.apple.com/ng/app/mamaket-mobile/id6469295262">
                  <img
                    src={apple}
                    alt="Download on Apple Store"
                    width="120"
                    height="40"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </Box>

          {/* FOOTER SIDE */}
          <div>
            <Box>
              {isAuthenticated && (
                <>
                  <Divider sx={{ mb: 2, bgcolor: "#EAEAEA80" }} />
                  <div className="px-3 mt-4 flex items-center gap-x-3">
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                    >
                      <Avatar>
                        {!userInfo?.imageUrl && getInitials(userInfo)}
                      </Avatar>
                    </StyledBadge>

                    <div className="flex flex-col">
                      <span className="font-bold text-[#272727]">{`${userInfo?.firstName} ${userInfo?.lastName}`}</span>
                      <span className="text-[12px] text-[#626262]">{`${userInfo?.email}`}</span>
                    </div>
                  </div>
                </>
              )}

              {isAuthenticated ? (
                <>
                  <div className="mx-5 my-5">
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={handleLogOut}
                      sx={{
                        fontWeight: 500,
                        color: "#575f6d",
                        bgcolor: "#F8F8F8",
                        height: "46px",
                        borderColor: "#001A2B1A",
                        borderRadius: "16px",
                      }}
                      startIcon={
                        <LiaPowerOffSolid className="text-[#FF383C]" />
                      }
                    >
                      Logout
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <Divider />
                  <div className="px-3 flex items-center gap-x-3 box-border my-10">
                    <Button
                      onClick={() => triggerAuth("signin")}
                      variant="outlined"
                      fullWidth
                      sx={{
                        height: "46px",
                        bgcolor: "#F8F8F8",
                        borderColor: "#001A2B1A",
                        borderRadius: "12px",
                        color: "#2E1834",
                      }}
                    >
                      Login
                    </Button>
                    <Button
                      onClick={() => triggerAuth("signup")}
                      variant="contained"
                      sx={{
                        bgcolor: "#2E1834",
                        height: "46px",
                        borderRadius: "12px",
                      }}
                      fullWidth
                    >
                      Create Account
                    </Button>
                  </div>
                </>
              )}
            </Box>
          </div>
        </Box>
      </Drawer>
      {/* </Popover> */}

      <div className="">
        <Box
          sx={{
            bgcolor: "#2E1834",
            py: 0.5,
            margin: "0 auto",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="">
              <div className="">
                <Typography
                  sx={{
                    fontWeight: 400,
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  Shop & Sell on the go!
                  <Link
                    className="ml-3"
                    to="/"
                    style={{
                      color: "#ffffff",
                      fontWeight: 700,
                    }}
                  >
                    Download Mamaket App
                  </Link>
                </Typography>
              </div>
            </div>
          </Box>
        </Box>
        <Box
          sx={{
            py: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "#2E1834",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", columnGap: 0.5 }}>
            <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
              <MenuIcon sx={{ color: "#fff" }} />
            </IconButton>
            <Link to="/">
              <img src={sLogo} className="w-[100px] " />
            </Link>
          </Box>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center", mr: 2 }}>
            {isAuthenticated ? (
              <>
                <IconButton>
                  <Link to="/cart">
                    <div className="flex items-center gap-x-2 cursor-pointer">
                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          alt="shopping_cart_icon"
                          src={shoppingCartIcon}
                          className="w-5 h-5"
                        />

                        <CartActionBadge>
                          {(product_cart &&
                            product_cart?.cartItems.length +
                              serviceCart?.serviceCarts.length) ||
                            0}
                        </CartActionBadge>
                      </Box>
                    </div>
                  </Link>
                </IconButton>
                <Link to="/wishlist">
                  <div className="flex items-center gap-x-2 cursor-pointer">
                    <Box
                      sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        alt="shopping_cart_icon"
                        src={wishListIcon}
                        className="w-5 h-5"
                      />
                      {favItems?.favItemsVar?.length > 0 && (
                        <CartActionBadge>
                          {favItems?.favItemsVar?.length > 99
                            ? "99+"
                            : favItems?.favItemsVar?.length}
                        </CartActionBadge>
                      )}
                    </Box>
                  </div>
                </Link>
              </>
            ) : (
              <>
                <Box sx={{ display: "flex", gap: 1, pr: 1 }}>
                  <div
                    onClick={() => triggerAuth("signin")}
                    className="flex items-center gap-x-2 cursor-pointer"
                  >
                    <img alt="login_icon" src={loginIcon} className="w-5 h-5" />
                    <Typography
                      sx={{ fontWeight: 500, color: "#fff", fontSize: "13px" }}
                    >
                      Login
                    </Typography>
                  </div>

                  <Typography sx={{ fontWeight: 500, color: "#1a1a1a" }}>
                    /
                  </Typography>

                  <Typography
                    onClick={() => triggerAuth("signup")}
                    sx={{
                      fontWeight: 500,
                      color: "#fff",
                      fontSize: "13px",
                      cursor: "pointer",
                    }}
                  >
                    Signup
                  </Typography>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </div>
    </>
  );
};

export default Drawers;

const ListLoader = () => {
  return (
    <>
      <Skeleton variant="square" sx={{ width: "30%", mb: 1 }} />
      <Skeleton variant="square" sx={{ width: "70%", mb: 1 }} />
      <Skeleton variant="square" sx={{ width: "50%", mb: 1 }} />
    </>
  );
};
